import type { ResolveStepAutoFill } from '@/features/campaigns/components/CreateCampaign_v2/steps/Whatsapp/types';
import { createNamedTemplateEditFlowHandler, type NamedTemplateSelection } from './namedTemplateEditFlowHandler';

export const createSmsEditFlowHandler = (selection?: NamedTemplateSelection): ResolveStepAutoFill =>
  createNamedTemplateEditFlowHandler(selection);
